<small [style.color]="selected?.color" [style.backgroundColor]="backgroundColor"
       [style.lineHeight]="backgroundColor?'30px':'15px'"
       class="d-flex justify-content-start text-view">
    <morva-icons class="icon-place icon-16 my-auto" [icon]="selected?.icon"></morva-icons>
    <span>
        {{ message }}
    </span>
</small>
